import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import './App.css';
// components
import Layout from "./components/Layout";

// pages
import Error from "./pages/error";
import Login from "./pages/login";
import VerifyEmail from "./pages/verifyEmail/VerifyEmail";

// context
import { useUserState } from "./context/UserContext";
import RedirectPage from "./pages/redirectPage/RedirectPage";

export default function App() {
  // global
  var { isAuthenticated } = useUserState();

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
        <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/dashboard" />}
        />
        <PrivateRoute path="/app" component={Layout} />
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/verify-email/:token" component={VerifyEmail} />
        <PublicRoute path="/:token/org/:organization/user/:username" render={() => <Redirect to="/app/dashboard" />} component={RedirectPage} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
